<template>
<div>
  <el-form ref="collectionRecordAddTable" :model="tableDataFrom" :rules="rules">
    <QS-common-table
      row-key="id"
      :columns="columns"
      :data="tableDataFrom.tableData"
      :pagination="false"
    >
    </QS-common-table>
  </el-form>
  <CategoryAdd
    :categoryShow="categoryShow"
    @cancelHandle="cancelHandle"
    @submitSuccess="submitSuccess"
  ></CategoryAdd>
</div>
</template>

<script>
import { limitMoreZero } from '@/utils/validate'
import selectOption from '@/store/dict/selectOptionDict'
import CategoryAdd from './CategoryAdd.vue'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  name: 'CollectionRecordAddTable',
  components: {
    CategoryAdd,
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      const index = rule.field.split('.')[1]
      const { remainAmount } = this.tableDataFrom.tableData[index]
      if (Number(value) <= Number(remainAmount) && Number(value) > 0 && remainAmount !== '') {
        callback()
      } else {
        if (Number(value) > Number(remainAmount)) {
          // eslint-disable-next-line vue/no-mutating-props
          this.tableDataFrom.tableData[index].amount = Number(remainAmount)
        }
        callback(new Error('请输入大于0至剩余应收范围内的金额'))
      }
    }
    return {
      columns: [
        {
          name: 'id',
          columnProps: {
            label: '应收ID',
            prop: 'id',
            width: 100,
          },
          render: ({ row }) => (
            <el-form-item>
              <span>{row.id}</span>
            </el-form-item>
          ),
        },
        {
          name: 'content',
          columnProps: {
            label: '收款内容',
            prop: 'content',
          },
          render: ({ row }) => (
            <el-form-item>
              <span>{this.freeTypeList[row.content] || ''}</span>
            </el-form-item>
          ),
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
          render: ({ row }) => (
            <el-form-item>
              <span>{row.plateNo}</span>
            </el-form-item>
          ),
        },
        {
          name: 'sourceOrderType',
          columnProps: {
            label: '来源单类型',
            prop: 'sourceOrderType',
            minWidth: '130',
          },
          render: ({ row }) => (
            <el-form-item>
              <span>
                {selectOption.sourceOrderTypeDict[row.sourceOrderType] || ''}
              </span>
            </el-form-item>
          ),
        },
        {
          name: 'sourceOrderId',
          columnProps: {
            label: '来源单ID',
            prop: 'sourceOrderId',
          },
          render: ({ row }) => (
            <el-form-item>
              <span>{row.sourceOrderId || ''}</span>
            </el-form-item>
          ),
        },
        {
          name: 'receivableDate',
          columnProps: {
            label: '应收日期',
            prop: 'receivableDate',
            width: 100,
          },
          render: ({ row }) => (
            <el-form-item>
              <span>{row.receivableDate || ''}</span>
            </el-form-item>
          ),
          type: 'date',
        },
        {
          name: 'receivableState',
          columnProps: {
            label: '收款状态',
            prop: 'receivableState',
          },

          render: ({ row }) => (
            <el-form-item>
              <span>
                {selectOption.batchStateDict[row.receivableState] || ''}
              </span>
            </el-form-item>
          ),
        },
        {
          name: 'receivableAmount',
          columnProps: {
            label: '应收金额（元）',
            prop: 'receivableAmount',
            minWidth: '130',
          },
          render: ({ row }) => (
            <el-form-item>
              <span>{this.numberWithCommas(row.receivableAmount) || ''}</span>
            </el-form-item>
          ),
        },
        {
          name: 'receivingAmount',
          columnProps: {
            label: '收款中金额（元）',
            prop: 'receivingAmount',
            minWidth: '150',
          },
          render: ({ row }) => (
            <el-form-item>
              <span>{this.numberWithCommas(row.receivingAmount) || ''}</span>
            </el-form-item>
          ),
        },
        {
          name: 'receivedAmount',
          columnProps: {
            label: '已收金额（元）',
            prop: 'receivedAmount',
            minWidth: '130',
          },
          render: ({ row }) => (
            <el-form-item>
              <span>{this.numberWithCommas(row.receivedAmount) || ''}</span>
            </el-form-item>
          ),
        },
        {
          name: 'remainAmount',
          columnProps: {
            label: '剩余应收金额（元）',
            prop: 'remainAmount',
            minWidth: '150',
          },
          render: ({ row }) => (
            <el-form-item>
              <span>{this.numberWithCommas(row.remainAmount) || ''}</span>
            </el-form-item>
          ),
        },
        {
          name: 'amount',
          columnProps: {
            label: '本次收款金额（元）',
            prop: 'amount',
            width: 230,
          },
          render: (scope) => (
            <el-form-item
              prop={`tableData.${scope.$index}.amount`}
              rules={this.rules.amount}
            >
              <el-input
                placeholder="请输入"
                v-model={scope.row.amount}
                onInput={(val) => this.amountChange(val, scope.$index)}
              ></el-input>
            </el-form-item>
          ),
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          render: (scope) =>
            (this.isShowDeleteBtn && (
              <el-popover
                ref={scope.$index}
                placement="bottom"
                width="230"
                popper-class="delete-order"
              >
                <p>确定删除该应收款项吗?</p>
                <div
                  class="delete-order-btns"
                  style={{ textAlign: 'right', margin: 0 }}
                >
                  <el-button
                    size="mini"
                    class="cancel-btn"
                    onClick={() => this.cancel()}
                  >
                    取消
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    onClick={() => this.handleDel(scope.row.serialNum)}
                  >
                    确定
                  </el-button>
                </div>
                <el-button type="text" slot="reference">
                  删除
                </el-button>
              </el-popover>
            )) ||
            '--',
        },

      ],

      rules: {
        amount: [
          {
            required: true,
            message: '本次收款金额不能为空',
            trigger: ['blur', 'change'],
          },
          { validator: validateAmount },
        ],
      },
      categoryShow: false,
    }
  },
  computed: {
    isShowDeleteBtn() {
      return this.tableDataFrom.tableData.length > 1
    },
  },
  watch: {
    'tableDataFrom.tableData': {
      handler(val) {
        if (val.length === 1) {
          // 当列表列数为14时
          if (this.columns?.length === 14) this.columns.pop()
        }
      },
      deep: true,
    },
  },
  props: {
    tableDataFrom: {
      type: Object,
      default: () => ({}),
    },
    // eslint-disable-next-line vue/no-unused-properties
    fundType: {
      type: [String, Number],
      default: '',
    },
    // eslint-disable-next-line vue/no-unused-properties
    customerId: {
      type: [String, Number],
      default: '',
    },
    freeTypeList: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    // 校验
    // eslint-disable-next-line vue/no-unused-properties
    handleValidate() {
      const {
        $refs,
        tableDataFrom: { tableData },
      } = this
      return new Promise((resolve) => {
        $refs.collectionRecordAddTable.validate((valid) => {
          if (!valid) {
            const notSubmit = tableData.some((item) => item.amount === '')
            if (notSubmit) this.$message.error('请填写收款金额')
            return false
          }
          resolve()
        })
      })
    },

    // popper弹框取消
    cancel() {
      // scope._self.$refs[scope.$index].doClose()
      // scope._self.$refs[scope.$index].showPopper = false
      document.body.click()
    },

    // 监听金额变化
    amountChange(value, index) {
      limitMoreZero(value, (val) => {
        this.$emit('amountChange', val, index)
      })
    },

    // 获取收款类型名称
    // eslint-disable-next-line vue/no-unused-properties
    getFreeTypeName(type) {
      return this.freeTypeList.find((item) => item.code === type).name
    },
    // 获取数据中type类型所在位置
    getIndex(key) {
      const _index = this.tableDataFrom.tableData.findIndex(
        (item) => item.serialNum === key,
      )
      return _index
    },

    // 删除条目
    handleDel(type) {
      this.$emit('handleDel', this.getIndex(type))
      this.cancel()
    },
    // 隐藏收款类目
    cancelHandle() {
      this.categoryShow = false
    },
    submitSuccess() {
      this.cancelHandle()
    },
  },
}
</script>

<style lang="scss" scoped>
.add-table ::v-deep .el-form-item {
  margin-top: 20px;
  margin-bottom: 20px;
}
.add-table ::v-deep td {
  padding: 0 !important;
}
.add-table {
  ::v-deep thead tr {
    background-color: #f7f8fa;
  }
}
#app .add-table ::v-deep thead tr th {
  border: none !important;
}
.delete-order {
  &-btns {
    text-align: right;
    margin: 0;
    display: flex;
    justify-content: flex-end;
    margin-top: 20px !important;
    .cancel-btn {
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      border: 1px solid #dcdee0;
      font-family: PingFangSC-Regular;
      color: #323233;
      border-radius: 3px;
      font-size: 12px;
    }
  }
}
</style>
